export const allcampuses = [
    { label: "Adventist University of Africa	Nairobi", value: "Adventist University of Africa	Nairobi" },
    { label: "Africa International University	Nairobi", value: "Africa International University	Nairobi" },
    { label: "Africa Nazarene University	Nairobi", value: "Africa Nazarene University	Nairobi" },
    { label: "Amref International University	Nairobi", value: "Amref International University	Nairobi" },
    { label: "Chuka University	Chuka", value: "Chuka University	Chuka" },
    { label: "Daystar University	Nairobi", value: "Daystar University	Nairobi" },
    { label: "Dedan Kimathi University of Technology	Nyeri", value: "Dedan Kimathi University of Technology	Nyeri" },
    { label: "Egerton University	Njoro ", value: "Egerton University	Njoro" },
    { label: "Garissa University	Garissa", value: "Garissa University	Garissa" },
    { label: "Great Lakes University of Kisumu	Kisumu", value: "Great Lakes University of Kisumu	Kisumu" },
    { label: "Gretsa University	Thika", value: "Gretsa University	Thika" },
    { label: "International Leadership University, Kenya	Nairobi", value: "International Leadership University, Kenya	Nairobi" },
    { label: "Jaramogi Oginga Odinga University of Science and Technology Bondo", value: "Jaramogi Oginga Odinga University of Science and Technology Bondo" },
    { label: "Kenyatta University of Agriculture and Technology	Nairobi ", value: "Kenyatta University of Agriculture and Technology	Nairobi" },
    { label: "Kabarak University	Nakuru", value: "Kabarak University	Nakuru" },
    { label: "East University	Nairobi", value: "East University	Nairobi" },
    { label: "Karatina University	Karatina", value: "Karatina University	Karatina" },
    { label: "KCA University	Nairobi", value: "KCA University	Nairobi" },
    { label: "Kenya Highlands University	Kericho", value: "Kenya Highlands University	Kericho" },
    { label: "Kenya Methodist University	Meru", value: "Kenya Methodist University	Meru" },
    { label: " Kenyatta University	Nairobi", value: "Kenyatta University	Nairobi" },
    { label: "Kibabii University	Bungoma", value: "Kibabii University	Bungoma" },
    { label: "Kirinyaga University	Kerugoya", value: "Kirinyaga University	Kerugoya" },
    { label: "Kiriri Women's University of Science and Technology	Nairobi", value: "Kiriri Women's University of Science and Technology	Nairobi" },
    { label: " Kisii University	Kisii", value: "Kisii University	Kisii" },
    { label: "Laikipia University	Nyahururu", value: "Laikipia University	Nyahururu" },
    { label: "Lukenya University	Kambu", value: "Lukenya University	Kambu" },
    { label: "Maasai Mara University	Narok", value: "Maasai Mara University	Narok" },
    { label: "Machakos University	Machakos", value: "Machakos University	Machakos" },
    { label: "Management University of Africa	Nairobi", value: "Management University of Africa	Nairobi" },
    { label: "Maseno University	Maseno", value: "Maseno University	Maseno" },
    { label: "Masinde Muliro University of Science and Technology	Kakamega", value: "Masinde Muliro University of Science and Technology	Kakamega" },
    { label: "Meru University of Science and Technology	Meru", value: "Meru University of Science and Technology	Meru" },
    { label: "Moi University	Eldoret", value: "Moi University	Eldoret" },
    { label: "Mount Kenya University	Thika", value: "Mount Kenya University	Thika" },
    { label: "Multimedia University of Kenya	Nairobi", value: "Multimedia University of Kenya	Nairobi" },
    { label: "Murang'a University of Technology	Murang'a", value: "Murang'a University of Technology	Murang'a" },
    { label: "Pan Africa Christian University	Nairobi", value: "Pan Africa Christian University	Nairobi" },
    { label: "Pioneer International University	Nairobi", value: "Pioneer International University	Nairobi" },
    { label: "Pwani University	Kilifi", value: "Pwani University	Kilifi" },
    { label: "RAF International University	Kisaju", value: "RAF International University	Kisaju" },
    { label: "Riara University	Nairobi", value: "Riara University	Nairobi" },
    { label: "Rongo University	Rongo", value: "Rongo University	Rongo" },
    { label: "Scott Christian University	Machakos", value: "Scott Christian University	Machakos" },
    { label: "South Eastern Kenya University	Kitui", value: "South Eastern Kenya University	Kitui" },
    { label: "St.Paul's University	Limuru ", value: "St.Paul's University	Limuru " },
    { label: "Strathmore University	Nairobi", value: "Strathmore University	Nairobi" },
    { label: "Taita Taveta University	Voi", value: "Taita Taveta University	Voi" },
    { label: "Technical University of Kenya	Nairobi", value: "Technical University of Kenya	Nairobi" },
    { label: "Technical University of Mombasa	Mombasa", value: "Technical University of Mombasa	Mombasa" },
    { label: "The Catholic University of Eastern Africa	Nairobi", value: "The Catholic University of Eastern Africa	Nairobi" },
    { label: "The Co - operative University of Kenya	Nairobi", value: "The Co - operative University of Kenya	Nairobi" },
    { label: "The East African University	Nairobi", value: "The East African University	Nairobi" },
    { label: "The Presbyterian University of East Africa	Kikuyu", value: "The Presbyterian University of East Africa	Kikuyu" },
    { label: "Umma University	Kajiado", value: "Umma University	Kajiado" },
    { label: "United States International University Africa	Nairobi", value: "United States International University Africa	Nairobi" },
    { label: "University of Eastern Africa, Baraton	Eldoret", value: "University of Eastern Africa, Baraton	Eldoret" },
    { label: "University of Eldoret	Eldoret", value: "University of Eldoret	Eldoret" },
    { label: "University of Embu	Embu", value: "University of Embu	Embu" },
    { label: "University of Kabianga	Kericho", value: "University of Kabianga	Kericho" },
    { label: "University of Nairobi	Nairobi ", value: "University of Nairobi	Nairobi" },
    { label: "Uzima University	Kisumu", value: "Uzima University	Kisumu" },
    { label: "Zetech University", value: "Zetech University" },

]


export const types = [
    { label: "Single room", value: "Single room" },
    { label: "Bedsitter", value: "Bedsitter" },
    { label: "1 Bedroom", value: "1 Bedroom" },
    { label: "2 Bedroom", value: "2 Bedroom" },
    { label: "3 Bedroom", value: "3 Bedroom" },
    { label: "4 Bedroom", value: "4 Bedroom" },
    { label: "Appartment", value: "Appartment" },
];

export const prices = [
    { label: "1000-5000", value: "1000-5000" },
    { label: "6000-10000", value: "6000-10000" },
    { label: "11000-15000", value: "11000-15000" },
    { label: "16000-20000", value: "16000-20000" },
    { label: "21000-25000", value: "21000-25000" },
    { label: "26000-30000", value: "26000-30000" },
    { label: "31000-35000", value: "31000-35000" },
    { label: "36000-40000", value: "36000-40000" },
    { label: "40000 and Above", value: "40000-100000" },
];



//blog dummy
export const dummyblog = [
    {
        id: 1,
        username: "Sarah some",
        userurl: require("./../../assets/landing/home7.png"),
        title: "Adding retries to EAS Webhooks",
        content: "Did you know that you can be alerted as soon as your EAS Build or Submit is done via webhooks? Now, we’re making webhooks more robust with retries, starting Monday, March 27th.",
        dateposted: "jan 20 2023",
        clicks: 72,
        minutes: 6,
        blogurl: require("./../../assets/common/blog.jpeg"),
    },
    {
        id: 2,
        username: "Sarah some",
        userurl: require("./../../assets/landing/home7.png"),
        title: "Adding retries to EAS Webhooks",
        content: "Did you know that you can be alerted as soon as your EAS Build or Submit is done via webhooks? Now, we’re making webhooks more robust with retries, starting Monday, March 27th.",
        dateposted: "jan 20 2023",
        clicks: 72,
        minutes: 6,
        blogurl: require("./../../assets/common/blog.jpeg"),
    }
]

//campus coodinates
export const campuscoordinates = [
    {
        campus: "Chuka university",
        latitude: -0.3191077,
        longitude: 37.6572086
    }
]


//customs
export const semesterroomtypes = [
    {
        label: "Single room",
        value: "Single room",
        distances: [
            {
                distance: "Less than 1km",
                price: 14000
            },
            {
                distance: "1km-2km",
                price: 12000
            },
            {
                distance: "2km-3km",
                price: 10000
            },
            {
                distance: "Over 3km",
                price: 8000
            }
        ]
    },
    {
        label: "Bedsitter",
        value: "Bedsitter",
        distances: [
            {
                distance: "Less than 1km",
                price: 22000
            },
            {
                distance: "1km-2km",
                price: 20000
            },
            {
                distance: "2km-3km",
                price: 18000
            },
            {
                distance: "Over 3km",
                price: 16000
            }
        ]
    },
    {
        label: "1 Bedroom",
        value: "1 Bedroom",
        distances: [
            {
                distance: "Less than 1km",
                price: 24000
            },
            {
                distance: "1km-2km",
                price: 24000
            },
            {
                distance: "2km-3km",
                price: 24000
            },
            {
                distance: "Over 3km",
                price: 20000
            }
        ]
    }
];



//month types
export const monthroomtypes = [
    {
        label: "Single room",
        value: "Single room",
        distances: [
            {
                distance: "Less than 1km",
                price: 'N/A'
            },
            {
                distance: "1km-2km",
                price: 'N/A'
            },
            {
                distance: "2km-3km",
                price: 2000
            },
            {
                distance: "Over 3km",
                price: 2000
            }
        ]
    },
    {
        label: "Bedsitter",
        value: "Bedsitter",
        distances: [
            {
                distance: "Less than 1km",
                price: 5000
            },
            {
                distance: "1km-2km",
                price: 5000
            },
            {
                distance: "2km-3km",
                price: 4000
            },
            {
                distance: "Over 3km",
                price: 4000
            }
        ]
    },
    {
        label: "1 Bedroom",
        value: "1 Bedroom",
        distances: [
            {
                distance: "Less than 1km",
                price: 6000
            },
            {
                distance: "1km-2km",
                price: 6000
            },
            {
                distance: "2km-3km",
                price: 6000
            },
            {
                distance: "Over 3km",
                price: 6000
            }
        ]
    }
];
export const customprices = [
    { label: "6000-10000", value: "6000-10000" },
    { label: "11000-15000", value: "11000-15000" },
    { label: "16000-20000", value: "16000-20000" },
    { label: "21000-25000", value: "21000-25000" },
    { label: "26000-30000", value: "26000-30000" },
];
export const numberofdays = [
    { label: "1 Day", value: 1 },
    { label: "2 Days", value: 2 },
    { label: "3 Days", value: 3 },
    { label: "4 Days", value: 4 },
    { label: "5 Days", value: 5 },
    { label: "6 Days", value: 6 },
    { label: "7 Days", value: 7 },
    { label: "8 Days", value: 8 },
    { label: "9 Days", value: 9 },
    { label: "10 Days", value: 10 },
    { label: "11 Days", value: 11 },
    { label: "12 Days", value: 12 },
    { label: "13 Days", value: 13 },
    { label: "14 Days", value: 14 },
];

export const Bedsitterpricing = [
    { label: "15000-19999", value: "15000-19999" },
    { label: "20000-24999", value: "20000-24999" },
    { label: "16000-20000", value: "16000-20000" },
    { label: "21000-25000", value: "21000-25000" },
    { label: "26000-30000", value: "26000-30000" },
];


export const roomdetails = [
    { label: "Dustbin", value: "dustbin" },
    { label: "Kitchen Sink", value: "kitchensink" },
    { label: "Bathroom", value: "bathroom" },
    { label: "Balcony", value: "balcony" },
    { label: "Ceiling", value: "ceiling" },
    { label: "Toilet", value: "toilet" },
    { label: "Bed", value: "bed" },
    { label: "Hot Shower", value: "hotshower" },
    { label: "Router", value: "router" },
    { label: "Gate", value: "gate" },
    { label: "Chair", value: "chair" },
    { label: "Tiles", value: "tiles" },
    { label: "Mattress", value: "mattress" },
];

export const contacttypes = [
    {
        label:"Whatsapp",
        value:"whatsapp"
    },
    {
        label:"Call",
        value:"call"
    },
    {
        label:"Sms",
        value:"sms"
    },
    {
        label:"Email",
        value:"email"
    }
]
